import appConfig from '@nerdwallet/app-config';

import { VERTICALS } from './constants';

const TABS = (withTravelVariant: boolean) => [
  VERTICALS.CREDIT_CARD,
  VERTICALS.BANKING,
  withTravelVariant ? VERTICALS.TRAVEL_VARIANT : VERTICALS.TRAVEL,
  VERTICALS.SMALL_BUSINESS,
  VERTICALS.PERSONAL_LOANS,
  VERTICALS.INSURANCE,
  VERTICALS.MORTGAGES,
  VERTICALS.INVESTING,
  VERTICALS.STUDENT_LOANS,
];

const verticalComparisonContent = (withTravelVariant = false) => ({
  // to break title into two lines, add \n where you want the lines to split
  title: 'Make smarter financial decisions with NerdWallet’s',
  typeModuleText: [
    'side-by-side comparisons',
    'objective ratings and reviews',
    'customized insights',
    'trusted expertise',
  ],
  backgroundImageUrl: `${appConfig.ASSETS_URL}/images/homepage/tab1-background.svg`,
  tabs: TABS(withTravelVariant),
});

export default verticalComparisonContent;
